import { Form, Button, Spinner } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

/**
 * Обёртка для форм создания/редактирования с единым дизайном
 */
export const FormLayout = ({ 
  children, 
  onSubmit, 
  onBack,
  saving = false,
  submitText = 'Сохранить',
  savingText = 'Сохранение...',
  backText = '← Назад к списку',
}) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit?.(e);
  };

  return (
    <Form onSubmit={handleSubmit} className="bg-white p-4 rounded-3 shadow-sm">
      {children}
      
      {/* Кнопки действий */}
      <div className="d-flex justify-content-between py-4 border-top">
        {onBack ? (
          <Button 
            variant="link" 
            className="text-secondary text-decoration-none px-0"
            onClick={onBack}
            type="button"
          >
            {backText}
          </Button>
        ) : <div />}
        <Button 
          variant="dark" 
          type="submit" 
          disabled={saving}
        >
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              {savingText}
            </>
          ) : (
            submitText
          )}
        </Button>
      </div>

      <ToastContainer position="bottom-right" />
    </Form>
  );
};
